/**
 * Retrieves a value from local storage by its key. If the key does not exist,
 * or an error occurs (e.g., if the value is not valid JSON), a default value is returned.
 *
 * @param {string} key - The key of the item to retrieve from local storage.
 * @param {*} defaultValue - The default value to return if the key is not found or if an error occurs. Defaults to null.
 * @returns {*} The value retrieved from local storage, parsed as JSON, or the default value.
 */
export const getFromLocalStorage = (key, defaultValue = null) => {
  if (typeof key !== "string") {
    console.error("Key must be a string");
    return defaultValue;
  }
  try {
    const data = localStorage.getItem(key);
    if (data === null) {
      return defaultValue;
    }
    return JSON.parse(data);
  } catch (error) {
    console.error(`Failed to parse ${key} from localStorage`, error);
    return defaultValue;
  }
};

/**
 * Saves a value to the browser's local storage with the specified key.
 * @param {string} key - The key under which to save the value in local storage.
 * @param {*} value - The value to be saved in local storage.
 */
export const saveOnLocalStorage = (key, value) => {
  const jsonValue = JSON.stringify(value);
  localStorage.setItem(key, jsonValue);
};
